import React from 'react';


const services = [
    {
        count: 1,
        title: 'Concrete Estimation',
        flaticon: 'flaticon-builder',
        description: 'Accurate concrete estimates for cost-effective material use, minimizing waste and controlling budget.',
    },
    {
        count: 2,
        title: 'Roofing Estimation',
        flaticon: 'flaticon-entrance',
        description: 'Precise roofing estimates to meet specifications, streamline procurement, and reduce waste.',
    },
    {
        count: 3,
        title: 'Painting Estimation',
        flaticon: 'flaticon-art-and-design',
        description: 'Detailed painting estimates to ensure accurate material usage and cost efficiency.',
    },
    {
        count: 4,
        title: 'Asphalt & Paving',
        flaticon: 'flaticon-road',
        description: 'Accurate asphalt and paving estimates to support smooth, cost-effective project planning.',
    },
    {
        count: 5,
        title: 'Mechanical & HVAC',
        flaticon: 'flaticon-crane',
        description: 'Precise mechanical and HVAC estimates to ensure efficient system installation and budgeting.',
    },
    {
        count: 6,
        title: 'Flooring Estimation',
        flaticon: 'flaticon-container',
        description: 'Detailed flooring estimates to ensure accurate material quantities and cost-effective project execution.',
    },
    {
        count: 7,
        title: 'Plumbing Estimation',
        flaticon: 'flaticon-barrier',
        description: 'Accurate plumbing estimates to ensure efficient installation and budget-friendly project planning.',
    },
    {
        count: 8,
        title: 'Electrical Estimation',
        flaticon: 'flaticon-rss',
        description: 'Precise electrical estimates to optimize material usage and ensure cost-effective project execution.',
    },
    {
        count: 9,
        title: 'Lumber Estimation',
        flaticon: 'flaticon-drill',
        description: 'Detailed lumber estimates to ensure accurate material calculations and cost-efficient project planning.',
    },
    {
        count: 10,
        title: 'Excavation Estimation',
        flaticon: 'flaticon-crane-1',
        description: 'Accurate excavation estimates to optimize material usage and ensure efficient project execution.',
    },
    {
        count: 11,
        title: 'Demolition Estimation',
        flaticon: 'flaticon-helmet',
        description: 'Precise demolition estimates to ensure accurate material removal and cost-effective project management.',
    },
    {
        count: 12,
        title: 'Openings Estimation',
        flaticon: 'flaticon-null',
        description: 'Accurate openings estimates to ensure precise material calculations and efficient project execution.',
    },
    {
        count: 13,
        title: 'Finishes Estimation',
        flaticon: 'flaticon-construction-and-tools',
        description: 'Detailed finishes estimates to ensure accurate material quantities and seamless project completion.',
    },
    {
        count: 14,
        title: 'Drywall & Coating',
        flaticon: 'flaticon-container',
        description: 'Precise drywall and coating estimates to ensure efficient material use and cost-effective project execution.',
    },
    {
        count: 15,
        title: 'Metal & Fabrications',
        flaticon: 'flaticon-wrench',
        description: 'Accurate metals and fabrication estimates to ensure precise material usage and budget control.',
    },
    {
        count: 16,
        title: 'Siteworks & Utilities',
        flaticon: 'flaticon-tower',
        description: 'Detailed sitework and utilities estimates to ensure efficient resource allocation and project success.',
    },
    {
        count: 17,
        title: 'Earthwork & Grading',
        flaticon: 'flaticon-transport',
        description: 'Precise earthwork and grading estimates to ensure efficient material use and project accuracy.',
    },
    {
        count: 18,
        title: 'Masonry & Restoration',
        flaticon: 'flaticon-worker',
        description: 'Accurate masonry and restoration estimates to ensure precise material use and project efficiency.',
    }
]

var img1 = require('./../../images/background/bg-5.png');
var img2 = require('./../../images/background/line.png');

class OurServices3 extends React.Component {
    componentDidMount(){
        function loadScript(src) {
           
          return new Promise(function(resolve, reject){
            var script = document.createElement('script');
            script.src = src;
            script.addEventListener('load', function () {
              resolve();
            });
            script.addEventListener('error', function (e) {
              reject(e);
            });
            document.body.appendChild(script);
            document.body.removeChild(script);
          })
        };
 
      loadScript('./assets/js/masonary.js');
      
    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white mobile-page-padding" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">All</span> Services</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE CAROUSEL START */}
                        <div className="section-content">
                            <div className="row">
                            {services.map((item, index) => (
                                <div key={index} className="col-md-4 col-sm-6">
                                    <div className="mt-icon-box-wraper p-a30 center m-b30 box-shadow bg-white">
                                        <div className="mt-icon-box-sm inline-icon text-primary  m-b20 radius bg-primary  scale-in-center bg-moving" style={{ backgroundImage: 'url(' + img2 + ')' }}>
                                            <span className="icon-cell text-secondry"><i className={item.flaticon} /></span>
                                        </div>
                                        <div className="icon-content">
                                            <h4 className="mt-tilte text-uppercase font-weight-600 m-b20">{item.title}</h4>
                                            <p>{item.description}</p>
                                        
                                        </div>
                                    </div>
                                </div>
                            ))}
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default OurServices3;